import {openNotice,closeNotice,getNoticeStatus,getNoticeItem,setNoticeItem} from '@/utils/profileutils'
const state = {
    noticeStatus:getNoticeStatus(),
    //选中的铃声
    noticeItem:getNoticeItem(),
    //播放语音提示的消息ID
    audioMsgId:0
}

const mutations = {
    OPEN_NOTICE(state) {
        state.noticeStatus = '1'
        openNotice()
    },
    CLOSE_NOTICE(state){
        state.noticeStatus = '0'
        closeNotice()
    },
    CHANE_NOTICE_ITEM(state,data){
        state.noticeItem = data
        setNoticeItem(data)
    },
    SET_AUDIO_MSG_ID(state,id){
        state.audioMsgId = id
    }
}

const actions = {
 
}
const getters = {
 
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
